import type { NewReport } from '../../hooks/useNewReport';
import { MetricLibraryModal } from './MetricLibraryModal';
import { MetricModal } from './MetricModal';
import { QuestionModal } from './QuestionModal';
import { SaveModal } from './SaveModal';
import { TableEditorModal } from './TableEditorModal';
import type { OverviewEditor } from './useOverviewEditor';

/** Renders whichever editor dialog is open. */
export function EditorModals({ report, editor }: { report: NewReport; editor: OverviewEditor }) {
  const { modal, setModal } = editor;
  const close = () => setModal(null);
  if (!modal) return null;
  if (modal.kind === 'question') return <QuestionModal editor={editor} index={modal.index} onClose={close} />;
  if (modal.kind === 'table')
    return (
      <TableEditorModal
        key={modal.component?.id ?? 'new'}
        report={report}
        component={modal.component}
        language={editor.language}
        onClose={close}
        onApply={(component) => {
          if (modal.component) editor.updateComponent(component);
          else editor.insertAt(component, modal.index ?? editor.components.length);
          close();
        }}
      />
    );
  if (modal.kind === 'metric') return <MetricModal report={report} editor={editor} state={modal} onClose={close} />;
  if (modal.kind === 'library') return <MetricLibraryModal editor={editor} index={modal.index} onClose={close} />;
  return <SaveModal onClose={close} />;
}
